<script setup lang="ts">

</script>

<template>
    <v-chip
        variant="flat"
        color="#C0DAF8"
        size="x-small"
        class="text-blue-darken-4 ml-2 px-2 text-caption"
    >
        Open
    </v-chip>
</template>

<style scoped>

</style>
